/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteSavedBrokerRequest
 */
export interface DeleteSavedBrokerRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteSavedBrokerRequest
     */
    savedBrokerId: string;
}

/**
 * Check if a given object implements the DeleteSavedBrokerRequest interface.
 */
export function instanceOfDeleteSavedBrokerRequest(value: object): value is DeleteSavedBrokerRequest {
    if (!('savedBrokerId' in value) || value['savedBrokerId'] === undefined) return false;
    return true;
}

export function DeleteSavedBrokerRequestFromJSON(json: any): DeleteSavedBrokerRequest {
    return DeleteSavedBrokerRequestFromJSONTyped(json, false);
}

export function DeleteSavedBrokerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteSavedBrokerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'savedBrokerId': json['savedBrokerId'],
    };
}

  export function DeleteSavedBrokerRequestToJSON(json: any): DeleteSavedBrokerRequest {
      return DeleteSavedBrokerRequestToJSONTyped(json, false);
  }

  export function DeleteSavedBrokerRequestToJSONTyped(value?: DeleteSavedBrokerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'savedBrokerId': value['savedBrokerId'],
    };
}

